<template>
    <!-- 首页头部导航栏 -->
	<div class="header-content">
        <el-row>
            <!-- 左侧 -->
          <el-col :span="12" class="left">
            <div class="logo">
                <Logo></Logo>
            </div>
            <div class="navbar">
		    	<ul class="menu">
		    		<li v-for="(item,index) in channels" :key="index">
                        <!-- 无下拉框 -->
		    			<router-link  v-if="item.single" class="item item-overflow"
		    				:to='{path:"/channel_detail/"+item.id}'>
		    				{{item.name}}
		    			</router-link>
                        <!-- 有下拉框 -->
		    			<router-link v-else class="item item-overflow"
		    				:to='{path:"/list_detail/"+item.id}'
		    				@mouseenter.native="openSubMenu(item)"
		    				@mouseleave.native="closeSubMenu(item)">
		    				{{item.name}}
		    				<transition name="fade" appear>
		    					<ul class="subMenu"  v-if="isOpen == item.name">
                                    <!-- isOpen == item.name -->
		    						<li class="sub-item" v-for="(subItem,subIndex) in item.children" :key="subIndex">
                                        <div class="front_icon">
                                           <i class="icon iconfont" :class="subItem.icon"></i>
                                        </div>
		    							<router-link v-if="subItem.single"  
		    								:to='"/channel/"+subItem.id'>
		    								{{subItem.name}}
		    							</router-link>
		    							<router-link v-else 
		    								:to='"/list/"+subItem.id'>
		    								{{subItem.name}}
		    							</router-link>
		    						</li>
		    					</ul>
		    				</transition>
		    			</router-link>
		    		</li>
		    	</ul>
		    </div>
          </el-col>
          <!-- 右侧 -->
          <el-col :span="12" class="right">
            <!-- search -->
            <div class="search_box">
                <i v-if="!searchVisible" class="el-icon-search" @click="showSearchBox"></i>
                <el-input v-if="searchVisible" v-model="searchValue" placeholder="输入您想要搜索的关键词" size="small" style="width:250px">
                  <template #suffix>
                      <i class="el-input__icon el-icon-search" @click="searchByKeywords"></i>
                      <span>|</span>
                      <i class="el-input__icon el-icon-close" @click="searchVisible = false"></i>
                  </template>
                </el-input>
            </div>
            <!-- console -->
            <div class="console">
                <a href="#/console">控制台</a>
            </div>
            <!-- 登录/注册 -->
            <div v-if="!isLogin" class="login_register"><a href="#/login">登录/注册</a></div>
            <div v-if="isLogin" class="head_portrait">
                <router-link :to="{path:'/accountCenter'}"
                    @mouseenter.native="accountVisible = true"
		    	    @mouseleave.native="accountVisible = false">
                    <img class="avatar_images" src="../../assets/console/user_avatar.png" alt="">
                    <router-link :to="{path:'/accountCenter'}">{{userInfo.username}}</router-link>
                    <transition name="fade" appear>
                        <!-- accountVisible -->
                        <div class="account_center" v-if="accountVisible">
                            <div class="account_item" @click="enterAccountCenter(0)">账户信息</div>
                            <div class="account_item" @click="enterAccountCenter(1)">账户认证</div>
                            <div class="account_item exit" @click="logout">退出</div>
                        </div>
                    </transition>
                </router-link>
            </div>
          </el-col>
        </el-row>
	</div>
</template>

<script>
    import { queryAllChannel } from '@/api/cms.js'
    import Logo from '@/components/common/logo.vue'
    import token from '@/utils/token.js'
    import store from '@/store'
    export default {
        components: {
            Logo,
        },
        data() {
            return {
                userInfo: {},
                channels: [],
                isOpen: '',
                // isLogin: store.getters.isLogin,
                isLogin: false,
                searchVisible: false, //搜索框是否可见
                searchValue: '',
                accountVisible: false,//账户中心下拉框是否可见
            }
        },
        mounted() {
            this.queryChannelList()
        },
        methods: {
            queryChannelList() {
                if (token.getUser()) {
                    this.isLogin = true;
                    this.userInfo = token.getUser();
                } else {
                    this.isLogin = false;
                }
                queryAllChannel().then(data => {
                    this.channels = this.getFirstNode(data.data.list)
                    // console.log("导航栏", this.channels)
                }).catch(error => {
                    this.$message.error(error)
                })
            },
            //获取一级节点
            getFirstNode(data) {
                let firstNodeList = []
                for (let i = 0; i < data.length; i++) {
                    let module = {
                        id: data[i].id,
                        icon: data[i].icon,
                        parentId: data[i].parentId,
                        parentName: '',
                        name: data[i].name,
                        single: data[i].single == 'Y' ? true : false,
                        sort: data[i].sort,
                        children: []
                    }
                    if (data[i].type === 0 && data[i].parentId === 0) {
                        firstNodeList.push(module)
                        module.children = this.getNextNode(data, data[i])
                    }
                }

                return firstNodeList
            },
            //获取二级及以下节点
            getNextNode(data, father) {
                let nextNodeList = []
                for (let i = 0; i < data.length; i++) {
                    let module = {
                        id: data[i].id,
                        icon: data[i].icon,
                        parentId: data[i].parentId,
                        parentName: '',
                        name: data[i].name,
                        single: data[i].single == 'Y' ? true : false,
                        sort: data[i].sort,
                        children: []
                    }
                    if (data[i].parentId === father.id) {
                        module.parentName = father.name
                        nextNodeList.push(module)
                        module.children = this.getNextNode(data, data[i])
                    }
                }
                return nextNodeList
            },
            openSubMenu(item) {
                if (item.children.length > 0) {
                    this.isOpen = item.name;
                }
            },
            closeSubMenu(item) {
                if (item.children.length > 0) {
                    this.isOpen = '';
                }
            },
            //搜索
            showSearchBox() {
                this.searchVisible = true;
                this.searchValue = '';
            },
            searchByKeywords() {

            },
            //账户中心
            enterAccountCenter(i) {
                this.$router.push({ path: '/accountCenter', query: { index:i} });
            },
            //退出登录
            logout() {
                token.clear();
                // this.$message.success('退出成功！');
                this.$router.go(0);//刷新当前页面
            }
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .header-content {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 80px;
        border-bottom: 1px solid #D7D7D7;
        background-color: #fff;
        .el-row {
            width: 100%;
            margin: auto;
            //左侧
            .left {
                display: flex;
                align-items: center;
                height: 80px;
                padding-left: 30px;
                .logo {
                    margin-right: 30px;
                }
                .navbar {
                    /* //控制border不撑大导航栏 */
                    height: 78px;
                    min-width: 500px;
                    margin-left: 0;
                    .menu {
                        /* //控制浏览器缩放时导航栏的隐藏问题 */
                        height: 80px;
                        overflow: hidden;
                        li {
                            display: inline-block;
                        }
                        .item {
                            padding: 0 25px;
                            line-height: 77px;
                            text-align: center;
                            border-bottom: 2px solid #fff;
                            .subMenu {
                                position: absolute;
                                top: 81px;
                                transform: translateX(-100px);
                                width: 340px;
                                background-color: #fff;
                                .sub-item {
                                    position: relative;
                                    display: block;
                                    text-align: left;
                                    .front_icon {
                                        position: absolute;
                                        top: 23px;
                                        left: 25px;
                                        width: 32px;
                                        height: 32px;
                                        background-color: #E2E4E9;
                                        color: #1A1919;
                                        text-align: center;
                                        line-height: 32px;
                                        border-radius: 50%;
                                    }
                                    a {
                                        display: inline-block;
                                        width: 100%;
                                        height: 100%;
                                        padding-left: 70px;
                                    }
                                }
                                .sub-item:hover {
                                    background-color: #e9efff;
                                    .front_icon {
                                        color: #fff;
                                        background: linear-gradient(to bottom right, #1FA3E5, #50D4A2);

                                    }
                                    a {
                                        color: #5783ee;
                                    }
                                }
                            }
                            // .fade-enter-active,
                            // .fade-leave-active {}
                        }
                        .item-overflow {
                            display: block;
                            word-break: keep-all;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .item:hover {
                            cursor: pointer;
                            color: #5783ee;
                            border-bottom: 2px solid #5783ee;
                        }
                    }
                }
            }
            //右侧
            .right {
                display: flex;
                justify-content: right;
                align-items: center;
                height: 80px;
                .search_box {
                    margin-right: 50px;
                    i {
                        font-size: 18px;
                        color: #5783ee;
                    }
                    i:hover {
                        cursor: pointer;
                    }
                    .el-icon-close {
                        font-size: 20px;
                    }
                    span {
                        margin: 0 5px;
                    }
                }
                .console {
                    a {
                        margin-right: 40px;
                        color: #507DF1;
                    }
                }
                .login_register {
                    a {
                        display: inline-block;
                        width: 236px;
                        height: 80px;
                        background-color: #537EEE;
                        font-size: 18px;
                        color: #fff;
                        text-align: center;
                        line-height: 80px;
                    }
                }
                .login_register:hover {
                    background-color: #6089F3;
                    cursor: pointer;
                }
                //头像
                .head_portrait {
                    position: relative;
                    height: 80px;
                    padding-right: 30px;
                    a{
                        display: inline-block;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        .avatar_images {
                            width: 45px;
                            height: 45px;
                            margin-right: 5px;
                            text-align: center;
                            border-radius: 50%;
                        }
                        .account_center {
                            position: absolute;
                            top: 81px;
                            right: 0px;
                            width: 150px;
                            .account_item {
                                height: 45px;
                                padding-left: 30px;
                                background-color: #fff;
                                color: #4F4F4F;
                                font-size: 14px;
                                line-height: 50px;
                            }
                            .account_item:hover {
                                background-color: #E9EFFF;
                                color: #3062E5;
                            }
                            .exit {
                                border-top: 1px solid #E5E5E5;
                            }
                        }
                    }
                }
            }
        }
    }
</style>